import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { _BusinessProcess, _FunctionalArea, _JobRequisition, _single, _TrainingRequest } from "../../../../core/services/dataBean/EntityCatalog";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable, MASK_DATE, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { FunctionalAreeaStateEditor } from "../../../admin/configuracion/FunctionalArea/FunctionalAreeaState.editor";
import { SelectFunctionalID } from "../../../admin/configuracion/functionalID/SelectFunctionalID";
import usePaginator from "../../../theme/Component/usePaginator";
import useModal, { MODAL_md, MODAL_XL } from "../../../theme/Component/hooks/useModal";
import { SelectIDFunctionalSingleton } from "../../../admin/select/SelectIDFunctionalSingleton";
import { Modal } from "../../../theme/Component/Modal";
import { TeamGroupMembersInfo } from "../../../admin/configuracion/functionalID/TeamGroupMembers/TeamGroupMembersInfo/TeamGroupMembersInfo";

interface componentProps {
    role: "BossArea" | "Admin"
}

type formEmployeContracs = {
    FunctionalArea: Record<string, any>;
    State: number;
}

type RequestProcessCode = "SOLCAP" | "SOLCONTRATACION";

export const EmployeeContractByIDLN = ({ role }: componentProps) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_FunctionalArea);
    const { instance: instanceJobRequisition } = useDataBean(_JobRequisition);
    const { instance: instanceTraining } = useDataBean(_TrainingRequest);
    const _busProcess = useDataBean(_BusinessProcess);
    const paginador = usePaginator();

    const [form, setForm] = useState<Partial<formEmployeContracs>>({});

    const modalInfo = useModal(`Informacion de ${bean.AccountName}`, MODAL_XL);
    const modalRequest = useModal("Solicitar contratacion de Personal", MODAL_md);
    const [requestProcessCode, setRequestProcessCode] = useState<RequestProcessCode>("SOLCONTRATACION");

    const buscar = () => {
        paginador.setPage(1);
        getLista();
    }

    const getLista = () => {
        if (!form.FunctionalArea?.IDLn) {
            toast.error("Debe seleccionar un area asignada")
            return;
        }

        instance.getFunctionalAreaCatalog(form.State, null, form.FunctionalArea?.IDLn, null, null, null, paginador.page, 15).then(
            (resp) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * 15);
                paginador.setRegiPerPage(15)

                setLista(resp.List.reverse())
            }
        ).catch(err => { toast.error(err) })
    }

    useEffect(() => {
        if (paginador.page && form.FunctionalArea?.IDLn) {
            getLista();
        }
    }, [paginador.page])

    const head = [
        { title: 'ID', property: 'IDLn', mask: MASK_NUMBER, visible: true },
        { title: 'Titular Plaza', property: 'AccountHolderName', visible: true },
        { title: 'Tipo de Labor', property: 'LabourTypeName', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Nivel Salarial', property: 'AppointmentName', visible: true },
        { title: 'Ubicación Geográfica de la Plaza', property: 'SiteIDName', visible: true },
        { title: 'Manual de Perfil y Funciones del Cargo', property: 'AppointmentManualName', visible: true },
        { title: 'Centro de Costo', property: 'CostingCenterName', visible: true },
        { title: 'Unidad Organizacional', property: 'FunctionalIDName', visible: true },
        { title: 'Codigo Área', property: 'FunctionalIDCode', visible: true },
        { title: 'Área', property: 'FunctionalIDName', visible: true },
        { title: 'Estado de la Plaza', property: 'StateName', visible: true },
        { title: 'IDContrato Laboral', property: 'IDContract', mask: MASK_NUMBER, visible: true },
        { title: 'Empleado', property: 'AccountName', visible: true },
        { title: 'Fecha Inicio', property: 'InitContract', visible: true },
        { title: 'Estado del Contrato', property: 'ContractStateName', visible: true },
        { title: 'Fecha de Creación', property: 'Since', mask: MASK_DATE, visible: true },

    ]

    const iconButtonsItem = [
        // { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const [obs, setObs] = useState<string>('');
    const [isValid, setIsValid] = useState<boolean>(false);

    const openRequestModal = (processCode: RequestProcessCode, title: string) => {
        setRequestProcessCode(processCode);
        setObs('');
        setIsValid(false);
        modalRequest.open(title);
    }

    const listaBotones = () => {
        const botones = [
            { titulo: 'Información del Empleado', icono: 'ri-file-user-line', visible: form.FunctionalArea?.IDBoss === _single.getAccountID() && bean.IDAccount, evento: () => { modalInfo.open() } },
            { titulo: 'Solicitud de Capacitación', icono: 'ri-file-user-line', visible: true, evento: () => { openRequestModal("SOLCAP", "Solicitar capacitación") } },
            { titulo: 'Solictar Contratacion de personal', icono: 'ri-user-search-line', visible: bean.State === 3, evento: () => { openRequestModal("SOLCONTRATACION", "Solicitar contratacion de Personal") } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const handleModalSubmit = () => {
        if (obs.trim().length < 15) {
            toast.error("La observación es obligatoria y debe tener al menos 15 caracteres.");
            setIsValid(true)
            return;
        }

        const isTrainingRequest = requestProcessCode === "SOLCAP";
        setIsValid(false);


        const obj = {
            IDAppointment: bean.IDAppointment,
            IDEmployeeContractType: bean.IDEmployeeContractType,
            IDEmploymentType: bean.IDEmploymentType,
            IDEntailment: bean.IDEntailment,
            IDLnFunctionalArea: bean.IDLn,
            IDLnFunctionalID: bean.IDLnFunctionalID,
            IDAccount: bean.IDAccount,
        }


        const requisitionBean = {
            IDEmployee: _single.getAccountID(),
            State: isTrainingRequest ? 6 : 1,
            IDLnFunctionalArea: bean.IDLn,
            IDLnFunctionalID: bean.IDLnFunctionalID,
            ...(isTrainingRequest ? { IDAccount: bean.IDAccount } : {}),
        };

        const updateRequisition = isTrainingRequest ? instanceTraining.updateTrainingRequest(requisitionBean) : instanceJobRequisition.updateJobRequisition(requisitionBean);

        updateRequisition.then(
            (resp: any) => {
                const requisitionID = isTrainingRequest ? { IDTrainingRequest: resp.IDTrainingRequest } : { IDJobRequisition: resp.IDJobRequisition };

                _busProcess.instance.requestBusinessProcess(_single.getAccountID(), obs, requestProcessCode, "FunctionalAreaIDLn", bean.IDLn, JSON.stringify({ ...obj, ...requisitionID }), "").then(
                    (respproces: any) => {
                        toast.success(`Se ha Generado el Proceso ${respproces.AlphaCode}`, { autoClose: false });
                        if (!isTrainingRequest) {
                            updateState(6)
                        }
                        modalRequest.close()
                        if (isTrainingRequest) {
                            updateTrainingRequisition({ ...resp, IDProcedureIMP: respproces.IDProcedureImp })
                        } else {
                            updateJobRequisition({ ...resp, IDProcedureIMP: respproces.IDProcedureImp })
                        }
                    }
                ).catch(err => { toast.error(err) })
            }
        ).catch(err => console.log(err));

    };

    const updateTrainingRequisition = (obj: any) => {
        instanceTraining.updateTrainingRequest(obj).then(
            (resp) => {
                console.log(resp)
            }
        ).catch(err => { console.info(err + " Error actualizando el historial") })
    }

    const updateJobRequisition = (obj: any) => {
        instanceJobRequisition.updateJobRequisition(obj).then(
            (resp) => {
                console.log(resp)
            }
        ).catch(err => { console.info(err + " Error actualizando el historial") })
    }

    const updateState = (state: number) => {
        const x = { ...bean, State: state }
        instance.updateFunctionalArea(x).then(
            (resp) => {
                getLista();
            }
        ).catch(err => { toast.error("No se pudo actualizar la plaza") })
    }


    return (
        <BasicPage titulo={role == "Admin" ? "Funcionarios en el Area" : "Funcionarios en mi Area"}>
            <div className="row">
                <div className="col-md-6">
                    <FunctionalAreeaStateEditor label="Estado" idSelector={form.State} onChange={(e) => { setForm({ ...form, State: e }) }} />
                </div>
                {role === "Admin" ?
                    <div className="col-md-6">
                        <SelectFunctionalID label="Unidad Organizacional" onChange={(e) => { setForm({ ...form, FunctionalArea: e }) }} />
                    </div>
                    :
                    <div className="col-md-6">
                        <SelectIDFunctionalSingleton returnType="Object" idSelector={form.FunctionalArea?.IDLn} onChange={(e) => { setForm({ ...form, FunctionalArea: e }) }} />
                    </div>
                }
                <div className="col-12 mt-2">
                    <BasicButton icon="" eventClick={buscar}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable iconButtons={iconButtonsItem} listButtons={listaBotones()} body={lista.reverse()} head={head} rowSet={setBean} records={paginador} />


                    <Modal modal={modalInfo.modal} updateModal={modalInfo.setModal}>
                        <TeamGroupMembersInfo groupMeber={bean} type="employeeContract" />
                    </Modal>

                    <Modal onSubmitLabel="Solicitar" modal={modalRequest.modal} updateModal={modalRequest.setModal} eventModal={handleModalSubmit}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Observaciones</label>
                                <textarea name="obs" rows={5} className={`form-control ${isValid ? "is-invalid" : ""}`} value={obs} onChange={(e) => setObs(e.target.value)} />
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>


        </BasicPage>
    )
}
